<!-- Page banner Area -->
<div class="page-banner bg-3">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="page-content">
                    <h2>Our Blog</h2>
                    <ul>
                        <li><a routerLink="/">Home</a></li>
                        <li>Blog</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- End Page banner Area -->

<!-- Blog Area -->
<div class="blog-area-two py-5" style="background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);">
    <div class="container">
        <div class="text-center mb-5" data-aos="fade-up">
            <span class="badge bg-light text-dark px-3 py-2 rounded-pill mb-3">Our Blog</span>
            <h2 class="fw-bold">Logistics Insights & News</h2>
            <p class="text-muted mt-3">Stay updated with the latest trends in global shipping and supply chain management</p>
        </div>

        <div class="row">
            <div class="col-lg-4 col-md-6 mb-4" data-aos="fade-up" data-aos-delay="100">
                <div class="card h-100 border-0 shadow-sm rounded-4 overflow-hidden">
                    <div class="card-img-top d-flex align-items-center justify-content-center" style="height: 180px; background: linear-gradient(135deg, #495057 0%, #6c757d 100%);">
                        <i class='bx bxs-package text-white' style="font-size: 64px;"></i>
                    </div>
                    <div class="card-body p-4">
                        <div class="d-flex align-items-center gap-2 mb-3">
                            <span class="badge rounded-pill px-3 py-1" style="background-color: #6c757d;">Supply Chain</span>
                            <small class="text-muted"><i class='bx bx-calendar me-1'></i>Dec 15, 2024</small>
                        </div>
                        <h5 class="card-title fw-bold mb-3">
                            <a routerLink="/blog-details" class="text-dark text-decoration-none">How to Optimize Your Supply Chain for 2024</a>
                        </h5>
                        <p class="card-text text-muted mb-4">Discover 5 proven strategies to streamline your logistics operations and reduce shipping costs by up to 30%.</p>
                        <a routerLink="/blog-details" class="btn btn-outline-dark rounded-pill px-4 py-2">Read More <i class='bx bx-arrow-right ms-1'></i></a>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 mb-4" data-aos="fade-up" data-aos-delay="200">
                <div class="card h-100 border-0 shadow-sm rounded-4 overflow-hidden">
                    <div class="card-img-top d-flex align-items-center justify-content-center" style="height: 180px; background: linear-gradient(135deg, #5a6c7d 0%, #7d8fa0 100%);">
                        <i class='bx bxs-plane-take-off text-white' style="font-size: 64px;"></i>
                    </div>
                    <div class="card-body p-4">
                        <div class="d-flex align-items-center gap-2 mb-3">
                            <span class="badge rounded-pill px-3 py-1" style="background-color: #6c757d;">Air Freight</span>
                            <small class="text-muted"><i class='bx bx-calendar me-1'></i>Dec 10, 2024</small>
                        </div>
                        <h5 class="card-title fw-bold mb-3">
                            <a routerLink="/blog-details" class="text-dark text-decoration-none">When to Choose Air Freight Over Sea Shipping</a>
                        </h5>
                        <p class="card-text text-muted mb-4">Learn the key factors that determine when air cargo is the right choice for your time-sensitive shipments.</p>
                        <a routerLink="/blog-details" class="btn btn-outline-dark rounded-pill px-4 py-2">Read More <i class='bx bx-arrow-right ms-1'></i></a>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 mb-4" data-aos="fade-up" data-aos-delay="300">
                <div class="card h-100 border-0 shadow-sm rounded-4 overflow-hidden">
                    <div class="card-img-top d-flex align-items-center justify-content-center" style="height: 180px; background: linear-gradient(135deg, #3d4f5f 0%, #5a6c7d 100%);">
                        <i class='bx bxs-rocket text-white' style="font-size: 64px;"></i>
                    </div>
                    <div class="card-body p-4">
                        <div class="d-flex align-items-center gap-2 mb-3">
                            <span class="badge rounded-pill px-3 py-1" style="background-color: #6c757d;">Technology</span>
                            <small class="text-muted"><i class='bx bx-calendar me-1'></i>Dec 5, 2024</small>
                        </div>
                        <h5 class="card-title fw-bold mb-3">
                            <a routerLink="/blog-details" class="text-dark text-decoration-none">The Future of Digital Freight Tracking</a>
                        </h5>
                        <p class="card-text text-muted mb-4">Explore how AI and IoT are revolutionizing shipment visibility across global supply chains.</p>
                        <a routerLink="/blog-details" class="btn btn-outline-dark rounded-pill px-4 py-2">Read More <i class='bx bx-arrow-right ms-1'></i></a>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 mb-4" data-aos="fade-up" data-aos-delay="100">
                <div class="card h-100 border-0 shadow-sm rounded-4 overflow-hidden">
                    <div class="card-img-top d-flex align-items-center justify-content-center" style="height: 180px; background: linear-gradient(135deg, #6c757d 0%, #8a9aa8 100%);">
                        <i class='bx bxs-file text-white' style="font-size: 64px;"></i>
                    </div>
                    <div class="card-body p-4">
                        <div class="d-flex align-items-center gap-2 mb-3">
                            <span class="badge rounded-pill px-3 py-1" style="background-color: #6c757d;">Compliance</span>
                            <small class="text-muted"><i class='bx bx-calendar me-1'></i>Nov 28, 2024</small>
                        </div>
                        <h5 class="card-title fw-bold mb-3">
                            <a routerLink="/blog-details" class="text-dark text-decoration-none">Navigating International Customs in 2024</a>
                        </h5>
                        <p class="card-text text-muted mb-4">Essential guide to customs regulations and documentation for smooth cross-border shipping.</p>
                        <a routerLink="/blog-details" class="btn btn-outline-dark rounded-pill px-4 py-2">Read More <i class='bx bx-arrow-right ms-1'></i></a>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 mb-4" data-aos="fade-up" data-aos-delay="200">
                <div class="card h-100 border-0 shadow-sm rounded-4 overflow-hidden">
                    <div class="card-img-top d-flex align-items-center justify-content-center" style="height: 180px; background: linear-gradient(135deg, #4a5a6a 0%, #6b7b8b 100%);">
                        <i class='bx bxs-leaf text-white' style="font-size: 64px;"></i>
                    </div>
                    <div class="card-body p-4">
                        <div class="d-flex align-items-center gap-2 mb-3">
                            <span class="badge rounded-pill px-3 py-1" style="background-color: #6c757d;">Sustainability</span>
                            <small class="text-muted"><i class='bx bx-calendar me-1'></i>Nov 20, 2024</small>
                        </div>
                        <h5 class="card-title fw-bold mb-3">
                            <a routerLink="/blog-details" class="text-dark text-decoration-none">Sustainable Shipping: Reducing Your Carbon Footprint</a>
                        </h5>
                        <p class="card-text text-muted mb-4">How eco-friendly logistics practices are shaping the future of global transportation.</p>
                        <a routerLink="/blog-details" class="btn btn-outline-dark rounded-pill px-4 py-2">Read More <i class='bx bx-arrow-right ms-1'></i></a>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 mb-4" data-aos="fade-up" data-aos-delay="300">
                <div class="card h-100 border-0 shadow-sm rounded-4 overflow-hidden">
                    <div class="card-img-top d-flex align-items-center justify-content-center" style="height: 180px; background: linear-gradient(135deg, #556070 0%, #758090 100%);">
                        <i class='bx bxs-buildings text-white' style="font-size: 64px;"></i>
                    </div>
                    <div class="card-body p-4">
                        <div class="d-flex align-items-center gap-2 mb-3">
                            <span class="badge rounded-pill px-3 py-1" style="background-color: #6c757d;">Warehousing</span>
                            <small class="text-muted"><i class='bx bx-calendar me-1'></i>Nov 15, 2024</small>
                        </div>
                        <h5 class="card-title fw-bold mb-3">
                            <a routerLink="/blog-details" class="text-dark text-decoration-none">Smart Warehousing: Automation in Logistics</a>
                        </h5>
                        <p class="card-text text-muted mb-4">Discover how automated warehouses are improving efficiency and accuracy in inventory management.</p>
                        <a routerLink="/blog-details" class="btn btn-outline-dark rounded-pill px-4 py-2">Read More <i class='bx bx-arrow-right ms-1'></i></a>
                    </div>
                </div>
            </div>

            <!-- Pagination -->
            <div class="col-lg-12 col-md-12 mt-4" data-aos="fade-up">
                <nav aria-label="Blog pagination">
                    <ul class="pagination justify-content-center">
                        <li class="page-item">
                            <a class="page-link rounded-pill mx-1" routerLink="/blog" style="border: none; background-color: #e9ecef; color: #495057;">
                                <span aria-hidden="true"><i class='bx bx-chevron-left'></i></span>
                            </a>
                        </li>
                        <li class="page-item active">
                            <a class="page-link rounded-pill mx-1" routerLink="/blog" style="border: none; background-color: #6c757d; color: white;">1</a>
                        </li>
                        <li class="page-item">
                            <a class="page-link rounded-pill mx-1" routerLink="/blog" style="border: none; background-color: #e9ecef; color: #495057;">2</a>
                        </li>
                        <li class="page-item">
                            <a class="page-link rounded-pill mx-1" routerLink="/blog" style="border: none; background-color: #e9ecef; color: #495057;">3</a>
                        </li>
                        <li class="page-item">
                            <a class="page-link rounded-pill mx-1" routerLink="/blog" style="border: none; background-color: #e9ecef; color: #495057;">
                                <span aria-hidden="true"><i class='bx bx-chevron-right'></i></span>
                            </a>
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
    </div>
</div>
<!-- End Blog Area -->